import CoreResize from '../../mixins/core-resize'
import AppPage from '../../mixins/app-page'

import AppTitle from '../app-title'
import AppBtnShare from '../app-btn-share'
import AppImgBg from '../app-img-bg'
import AppImg from '../app-img'
import AppNews from '../app-news'
import AppNewsSlideshow from '../app-news-slideshow'
import AppNewsSlideshowMobile from '../app-news-slideshow-mobile'
import AppFadein from '../app-fadein'
import AppBtn from '../app-btn'
import AppBtnFilter from '../app-btn-filter'


// URL list
import URL from '../../../config.url'


export default
{
    name: 'page-news',

    mixins:
    [
        AppPage,
        CoreResize
    ],

    components: {
        AppTitle,
        AppBtnShare,
        AppImgBg,
        AppImg,
        AppNews,
        AppNewsSlideshow,
        AppNewsSlideshowMobile,
        AppFadein,
        AppBtn,
        AppBtnFilter
    },

    watch:
    {
        contentPage: '_sortNews'
    },

    data()
    {
        return {
            news: [],
            newsSlideshow: [],
            newsList: [],
            newsShown: 0,
            filterVideoGame: null,
            isMoreBtnEnable: false,
            empty: true
        }
    },

    created()
    {
        this.newsOriginal = JSON.parse(JSON.stringify(this.contentPage.list))

        // Remove this when API will be built
        this.newsOriginal.forEach((news, index) =>
        {
            if (index % 3 === 0)
            {
                news.videoGameID = 1
            }
            else if (index % 3 === 1)
            {
                news.videoGameID = 2
            }
            else
            {
                news.videoGameID = 3
            }

            // For testing on mobile devices
            if (!news.resume) news.resume = 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Inventore ratione laborum amet aliquid, cupiditate reiciendis sed, deserunt, minima deleniti ipsum impedit doloribus nobis aspernatur ut, quod accusantium incidunt illum. Quidem!'
        })

        // For testing on mobile devices
        this.contentPage.gameOverall = {
            id: 0,
            name: 'Franchise',
            slug: 'franchise'
        }
        //

        // Add videoGame w/ ID 0 to get all news
        this._videoGames = JSON.parse(
            JSON.stringify(
                this.contentGlobal.videoGames.concat([this.contentPage.gameOverall])
            )
        )

        // Add more news
        this._moreNews()

        // Filter news for all video games
        this._onFilterVideoGameOverall()

        // Force intro animation
        setTimeout(() =>
        {
            this.empty = false
        }, 1000)
    },

    mounted()
    {
        // this.eventHub.$emit('bg-change', '/static/bg/bg-news.jpg')
    },

    methods:
    {
        // CORE
        onResized()
        {
            this._splitNews()
        },

        // GETTERS
        // Get article type w/ its ID
        getArticleTypeById(id)
        {
            return this.contentGlobal.postTypes.find(type => type.id === id)
        },

        // Get article URL w/ its slug
        getArticleUrlBySlug(slug)
        {
            return this.$root.getPageURLFromID('article').replace(':slug', slug)
        },

        // HTML ATIONS
        openModalRegister()
        {
            this.$root.openModalPlay('news')
        },

        // LOGIC
        _moreNews()
        {
            this.newsShown += 9

            this._splitNews()
        },

        _moreCheck()
        {
            this.isMoreBtnEnable = this.newsShown < this.newsList.length
        },

        _splitNews()
        {
            // If there is more than 5 news
            // Split the array on the arrays
            // Else
            // Don't show the slideshow
            if (this.newsOriginal.length > 5)
            {
                this.newsSlideshow = this.newsOriginal.slice(0, 5)
                this.newsList = this.newsOriginal.slice(5, -1)
            }
            else
            {
                this.newsSlideshow = []
                this.newsSlideshow.length = 0

                this.newsList = this.newsOriginal
            }

            this._sortNews()
        },

        _sortNews()
        {
            const news = []
            news.length = 0

            // Sort news from it date
            this.newsList.sort((a, b) => b.date - a.date)

            this.news = this.newsList.filter((n, index) => index < this.newsShown)

            this._moreCheck()

            this.$nextTick(() => this.$emit('load', this))
        },

        // FILTERS
        _getVideoGameFromID(id)
        {
            return this._videoGames.find(videoGame =>
            videoGame.id === id)
        },

        _onFilterVideoGameOverall()
        {
            this.eventHub.$emit('bg-change', '/static/bg/bg-empty.jpg')
            this.filterVideoGame = this._getVideoGameFromID(0)

            this.newsShown = 9
            this._sortNews()
        },

        _onFilterVideoGameCSGO()
        {
            this.eventHub.$emit('bg-change', '/static/bg/bg-counter-strike-global-offensive.jpg')
            this.filterVideoGame = this._getVideoGameFromID(1)

            this.newsShown = 9
            this._sortNews()
        },

        _onFilterVideoGameSFV()
        {
            this.eventHub.$emit('bg-change', '/static/bg/bg-street-fighter-v.jpg')
            this.filterVideoGame = this._getVideoGameFromID(2)

            this.newsShown = 9
            this._sortNews()
        },

        _onFilterVideoGameRL()
        {
            this.eventHub.$emit('bg-change', '/static/bg/bg-rocket-league.jpg')
            this.filterVideoGame = this._getVideoGameFromID(3)

            this.newsShown = 9
            this._sortNews()
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/page-news/script.js